import "@layui/layui-vue/lib/index.css"

import layui from "@layui/layui-vue"
import {createApp} from "vue";
import IndexComponent from "@/components/IndexComponent";
import AppRouter from "@/AppRouter";
import naiveUI from "naive-ui"

createApp(IndexComponent)
    .use(layui)
    .use(naiveUI)
    .use(AppRouter)
    .mount("#app");